export default "__VITE_ASSET__cFF$B$Jj__"